export default {
      id: "list_style_list-usage",
      viewBox: "0 0 30.1 23.6",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#list_style_list-usage",
      toString: function () {
        return this.url;
      }
    }